import createFormulierenRoutes, { FormulierenRoutes } from './Formulieren';
import { RouteConfig, SubRouteConfig } from '@vfpf/vfpf-shared';

type Routes = SubRouteConfig<
  RouteConfig,
  {
    Formulieren: FormulierenRoutes;
  }
>;

const Root = '';

export const ROUTE_CONFIG: Routes = {
  path: Root,
  subRoutes: {
    Formulieren: createFormulierenRoutes(Root),
  },
};
